module.exports = __webpack_public_path__ + "static/bagel-0810b76089d6df51a169c4882b81c6f2.webp";